$(document).on('ajax:success', function(e, xhr) {
    if (!$('#modal').length) {
        $('body').append('<div class="modal fade" id="modal" tabindex="-1" aria-hidden="true"></div>');
    }

    const $modal = $('#modal');
    $modal.html(xhr);
    $modal[0].offsetHeight; // force reflow
    $modal.modal('show');

    // pastikan aria-hidden false setelah tampil
    $modal.on('shown.bs.modal', function () {
        $(this).attr('aria-hidden', 'false');
    });

    // hilangkan fokus dari tombol sebelum modal close
    $modal.on('hide.bs.modal', function () {
        document.activeElement.blur();
    });

    // kosongkan modal setelah benar-benar tertutup
    $modal.on('hidden.bs.modal', function () {
        $(this).attr('aria-hidden', 'true').empty();
    });
});
